export const getVehicleType = state => state.ui.vehicleType;
export const getLanguage = state => state.ui.language;
